module.exports = __webpack_public_path__ + "img/es-howWork.83553046.png";